import React from "react";
import LightBoxModal from "./LightBoxModal";
const ImageLightBox = ({
  imageUrl,
  isOpen,
  onClose
}) => isOpen ? /*#__PURE__*/React.createElement(LightBoxModal, {
  imageUrl: imageUrl,
  close: onClose
}) : null;
export default ImageLightBox;
//# sourceMappingURL=ImageLightBox.js.map